import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ehp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Uploaded images come back as "/api/uploads/:id" — prefix with backend URL.
export const assetUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

export const apiErr = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return fallback;
};
